import Phaser from "phaser";
import { Tex } from "../ui/textures";
import { makeButton } from "../ui/widgets";

interface GameOverData {
  returnScene: string;
}

export class GameOverScene extends Phaser.Scene {
  constructor() {
    super("GameOver");
  }

  create(data: GameOverData) {
    const { width, height } = this.scale;
    const returnScene = data.returnScene ?? "LevelSelect";

    const bg = this.add.image(width / 2, height / 2, Tex.gameOver);
    const scaleX = width / bg.width;
    const scaleY = height / bg.height;
    bg.setScale(Math.max(scaleX, scaleY));

    makeButton(this, width / 2, height - 60, "↻  Try Again", () => this.scene.start(returnScene), {
      width: 220,
      fill: 0x3355aa,
    });
  }
}
